import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import {
  FiUsers, FiSearch, FiLoader, FiChevronDown, FiChevronUp,
  FiCheck, FiX, FiPhone, FiMail
} from "react-icons/fi";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');

  .gt-root {
    font-family: 'Montserrat', sans-serif;
    padding: 24px;
    max-width: 80rem;
    margin: 0 auto;
    min-height: 100vh;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  @media (max-width: 640px) {
    .gt-root {
      padding: 16px;
    }
  }

  /* Header */
  .gt-header {
    margin-bottom: 32px;
  }

  .gt-title {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, #1e293b, #475569);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 8px;
  }

  @media (min-width: 640px) {
    .gt-title {
      font-size: 30px;
    }
  }

  .gt-subtitle {
    color: #6b7280;
  }

  /* Summary Cards */
  .gt-summary-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 32px;
  }

  @media (min-width: 768px) {
    .gt-summary-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .gt-summary-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    padding: 24px;
    border-left: 4px solid;
  }

  .gt-summary-card-blue {
    border-left-color: #3b82f6;
  }

  .gt-summary-card-purple {
    border-left-color: #8b5cf6;
  }

  .gt-summary-card-green {
    border-left-color: #22c55e;
  }

  .gt-summary-card-teal {
    border-left-color: #14b8a6;
  }

  .gt-summary-label {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 4px;
  }

  .gt-summary-value {
    font-size: 28px;
    font-weight: 700;
    color: #1f2937;
  }

  /* Level Filter */
  .gt-filter-wrap {
    margin-bottom: 24px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .gt-filter-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'Montserrat', sans-serif;
  }

  .gt-filter-btn-all {
    background: #3b82f6;
    color: #ffffff;
  }

  .gt-filter-btn-all:hover {
    background: #2563eb;
  }

  .gt-filter-btn-level {
    background: #e5e7eb;
    color: #374151;
  }

  .gt-filter-btn-level:hover {
    background: #d1d5db;
  }

  .gt-filter-btn-active {
    background: #22c55e !important;
    color: #ffffff !important;
  }

  .gt-filter-btn-active:hover {
    background: #16a34a !important;
  }

  /* Search */
  .gt-search-wrap {
    margin-bottom: 24px;
    position: relative;
  }

  .gt-search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
  }

  .gt-search-input {
    width: 100%;
    padding: 12px 16px 12px 40px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    outline: none;
    transition: all 0.2s;
  }

  .gt-search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
  }

  /* Table */
  .gt-table-wrap {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .gt-table-scroll {
    overflow-x: auto;
  }

  .gt-table {
    width: 100%;
    border-collapse: collapse;
  }

  .gt-table-head {
    background: #f9fafb;
  }

  .gt-table-head th {
    padding: 12px 24px;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .gt-table-body {
    border-top: 1px solid #e5e7eb;
  }

  .gt-table-body tr {
    border-bottom: 1px solid #e5e7eb;
    transition: background 0.2s;
  }

  .gt-table-body tr:hover {
    background: #f9fafb;
  }

  .gt-table-body td {
    padding: 16px 24px;
  }

  .gt-empty-row td {
    padding: 48px 24px;
    text-align: center;
    color: #6b7280;
  }

  /* Member Info */
  .gt-member {
    display: flex;
    align-items: center;
  }

  .gt-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .gt-member-name {
    font-weight: 500;
    color: #1f2937;
  }

  /* Level Badge */
  .gt-level-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
    background: #dbeafe;
    color: #1e40af;
  }

  /* Status Badges */
  .gt-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
  }

  .gt-badge-active {
    background: #d1fae5;
    color: #065f46;
  }

  .gt-badge-inactive {
    background: #fee2e2;
    color: #991b1b;
  }

  .gt-badge-icon {
    margin-right: 4px;
  }

  /* Program Badges */
  .gt-program-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 500;
    margin-right: 4px;
  }

  .gt-program-lbbp {
    background: #ede9fe;
    color: #5b21b6;
  }

  .gt-program-puap {
    background: #d1fae5;
    color: #065f46;
  }

  .gt-program-group {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }

  /* Expand Button */
  .gt-expand-btn {
    background: none;
    border: none;
    color: #3b82f6;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .gt-expand-btn:hover {
    color: #1d4ed8;
  }

  /* Expanded Row */
  .gt-expanded {
    background: #f9fafb;
  }

  .gt-expanded-cell {
    padding: 16px 24px;
  }

  .gt-expanded-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (min-width: 768px) {
    .gt-expanded-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .gt-expanded-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #6b7280;
  }

  .gt-expanded-item svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  /* Loading State */
  .gt-loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  .gt-loading-content {
    text-align: center;
  }

  .gt-spinner {
    animation: gt-spin 1s linear infinite;
    font-size: 36px;
    color: #3b82f6;
    margin: 0 auto 16px;
    display: block;
  }

  @keyframes gt-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .gt-loading-text {
    color: #6b7280;
  }

  /* Error State */
  .gt-error {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f1f5f9 0%, #eff6ff 50%, #f1f5f9 100%);
  }

  .gt-error-content {
    text-align: center;
    color: #ef4444;
  }

  .gt-error-text {
    margin-bottom: 16px;
  }

  .gt-retry-btn {
    padding: 8px 16px;
    background: #3b82f6;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    transition: background 0.2s;
  }

  .gt-retry-btn:hover {
    background: #2563eb;
  }

  /* Responsive */
  @media (max-width: 640px) {
    .gt-table-body td {
      padding: 12px 16px;
    }

    .gt-table-head th {
      padding: 10px 16px;
      font-size: 10px;
    }

    .gt-avatar {
      width: 32px;
      height: 32px;
      font-size: 12px;
      margin-right: 8px;
    }

    .gt-summary-value {
      font-size: 22px;
    }

    .gt-expanded-grid {
      grid-template-columns: 1fr;
    }

    .gt-filter-wrap {
      gap: 4px;
    }

    .gt-filter-btn {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

const GenerationTeam = ({ user }) => {
  const [members, setMembers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [selectedLevel, setSelectedLevel] = useState("all");

  useEffect(() => {
    fetchGenerationTeam();
  }, []);

  const fetchGenerationTeam = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/puap/generation-team");
      setMembers(data.members);
      setSummary(data.summary);
    } catch (err) {
      setError(err.response?.data?.error || "Failed to load generation team");
    } finally {
      setLoading(false);
    }
  };

  const toggleRow = (id) => {
    const set = new Set(expandedRows);
    set.has(id) ? set.delete(id) : set.add(id);
    setExpandedRows(set);
  };

  const getFilteredMembers = () => {
    let filtered = members;
    if (selectedLevel !== "all") {
      const levelNum = parseInt(selectedLevel);
      filtered = members.filter(m => m.level === levelNum);
    }
    
    const q = searchTerm.toLowerCase();
    return filtered.filter(m => {
      return (
        (m.name?.toLowerCase() || "").includes(q) ||
        (m.uniqueId?.toLowerCase() || "").includes(q) ||
        (m.mobile?.toLowerCase() || "").includes(q) ||
        (m.email?.toLowerCase() || "").includes(q)
      );
    });
  };

  const filteredMembers = getFilteredMembers();

  if (loading) {
    return (
      <div className="gt-loading">
        <style>{styles}</style>
        <div className="gt-loading-content">
          <FiLoader className="gt-spinner" />
          <p className="gt-loading-text">Loading generation team...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="gt-error">
        <style>{styles}</style>
        <div className="gt-error-content">
          <p className="gt-error-text">{error}</p>
          <button onClick={fetchGenerationTeam} className="gt-retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="gt-root">
      <style>{styles}</style>

      <div className="gt-header">
        <h1 className="gt-title">Generation Team</h1>
        <p className="gt-subtitle">View your entire downline across all levels</p>
      </div>

      {summary && (
        <div className="gt-summary-grid">
          <div className="gt-summary-card gt-summary-card-blue">
            <div className="gt-summary-label">Total Members</div>
            <div className="gt-summary-value">{summary.totalMembers}</div>
          </div>
          <div className="gt-summary-card gt-summary-card-purple">
            <div className="gt-summary-label">Total Levels</div>
            <div className="gt-summary-value">{summary.totalLevels}</div>
          </div>
          <div className="gt-summary-card gt-summary-card-green">
            <div className="gt-summary-label">Active Members</div>
            <div className="gt-summary-value">{summary.activeMembers}</div>
          </div>
          <div className="gt-summary-card gt-summary-card-teal">
            <div className="gt-summary-label">PU&AP Active</div>
            <div className="gt-summary-value">{summary.puapActiveMembers}</div>
          </div>
        </div>
      )}

      <div className="gt-filter-wrap">
        <button
          onClick={() => setSelectedLevel("all")}
          className={`gt-filter-btn ${selectedLevel === "all" ? "gt-filter-btn-active" : "gt-filter-btn-all"}`}
        >
          All Levels
        </button>
        {Object.keys(summary?.levelCounts || {}).map(level => (
          <button
            key={level}
            onClick={() => setSelectedLevel(level)}
            className={`gt-filter-btn ${selectedLevel === level ? "gt-filter-btn-active" : "gt-filter-btn-level"}`}
          >
            Level {level} ({summary.levelCounts[level]})
          </button>
        ))}
      </div>

      <div className="gt-search-wrap">
        <FiSearch className="gt-search-icon" />
        <input
          type="text"
          placeholder="Search by name, ID, phone, or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="gt-search-input"
        />
      </div>

      <div className="gt-table-wrap">
        <div className="gt-table-scroll">
          <table className="gt-table">
            <thead className="gt-table-head">
              <tr>
                <th>Member</th>
                <th>ID</th>
                <th>Level</th>
                <th>Status</th>
                <th>Programs</th>
                <th>Join Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="gt-table-body">
              {filteredMembers.length === 0 ? (
                <tr className="gt-empty-row">
                  <td colSpan="7" className="gt-empty-row">
                    No members found
                  </td>
                </tr>
              ) : (
                filteredMembers.map((member) => (
                  <React.Fragment key={member._id}>
                    <tr>
                      <td>
                        <div className="gt-member">
                          <div className="gt-avatar">
                            {member.name?.charAt(0).toUpperCase() || "U"}
                          </div>
                          <div className="gt-member-name">{member.name}</div>
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: '14px', color: '#1f2937' }}>{member.uniqueId}</div>
                      </td>
                      <td>
                        <span className="gt-level-badge">Level {member.level}</span>
                      </td>
                      <td>
                        {member.isActive ? (
                          <span className="gt-badge gt-badge-active">
                            <FiCheck className="gt-badge-icon" size={12} /> Active
                          </span>
                        ) : (
                          <span className="gt-badge gt-badge-inactive">
                            <FiX className="gt-badge-icon" size={12} /> Inactive
                          </span>
                        )}
                      </td>
                      <td>
                        <div className="gt-program-group">
                          {member.isShareActive && (
                            <span className="gt-program-badge gt-program-lbbp">LBBP</span>
                          )}
                          {member.isProductActive && (
                            <span className="gt-program-badge gt-program-puap">PU&AP</span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize: '14px', color: '#1f2937' }}>
                          {member.joinDate ? new Date(member.joinDate).toLocaleDateString() : "N/A"}
                        </div>
                      </td>
                      <td>
                        <button
                          onClick={() => toggleRow(member._id)}
                          className="gt-expand-btn"
                        >
                          {expandedRows.has(member._id) ? (
                            <FiChevronUp size={20} />
                          ) : (
                            <FiChevronDown size={20} />
                          )}
                        </button>
                      </td>
                    </tr>
                    {expandedRows.has(member._id) && (
                      <tr className="gt-expanded">
                        <td colSpan="7" className="gt-expanded-cell">
                          <div className="gt-expanded-grid">
                            {member.mobile && (
                              <div className="gt-expanded-item">
                                <FiPhone />
                                {member.mobile}
                              </div>
                            )}
                            {member.email && (
                              <div className="gt-expanded-item">
                                <FiMail />
                                {member.email}
                              </div>
                            )}
                            {member.sponsorId && (
                              <div className="gt-expanded-item">
                                <FiUsers />
                                Sponsor ID: {member.sponsorId}
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GenerationTeam;